// Preload fonts
;(async function preloadFonts() {
  if (!document.fonts) return

  await document.fonts.ready

  const fonts = ['400 16px "Inter"', '700 16px "Inter"']

  const loadPromises = fonts.map(font => document.fonts.load(font))

  await Promise.all(loadPromises)
})()

export type { TicketElement } from './TicketElement'

export { BODY_FONT, TITLE_FONT, splitLines, wrapText } from './text.utils'
export { formatDate, formatDateWithoutTime, formatCurrency } from './fomatter.utils'

export type {
  DoubleTitleOptions,
  LabelOptions,
  InfoItemOptions,
  DoubleInfoItemOptions,
  DoubleLabelOptions,
  Payment,
  TillMethod,
  TaxRate,
  ProductStock
} from './types'

export { Logo } from './images/Logo'
export { CustomImage } from './images/CustomImage'

export { AdditionalInfo } from './text/AdditionalInfo'
export { Company } from './text/Company'
export { Title } from './text/Title'
export { SubTitle } from './text/SubTitle'
export { DoubleTitle } from './text/DoubleTitle'
export { Section } from './text/Section'
export { Label } from './text/Label'
export { InfoItem } from './text/InfoItem'
export { DoubleInfoItem } from './text/DoubleInfoItem'
export { DoubleLabel } from './text/DoubleLabel'
export { Tab } from './text/Tab'
export { Total } from './text/Total'
export { BillTaxesBreakdown } from './text/BillTaxesBreakdown'

export { Separator } from './separators/Separator'
export { InputLine } from './text/InputLine'
export { DottedSeparator } from './separators/DottedSeparator'
export { EmptySeparator } from './separators/EmptySeparator'

export { KitchenProduct } from './products/KitchenProduct'
export { Product } from './products/Product'

export { Box } from './containers/Box'
export { PaymentsBox } from './containers/PaymentsBox'
export { If } from './containers/If'

export { Barcode } from './barcodes/Barcode'
export { QR } from './barcodes/QR'

export { TillBreakdown } from './reports/TillBreakdown'
export { TaxesBreakdown } from './reports/TaxesBreakdown'
export { ProductsStockBreakdown } from './reports/ProductsStockBreakdown'
export { MovementsBreakdown } from './reports/MovementsBreakdown'
